<a class="text-info mx-1" title="Open help" *ngIf="forceVisible || (stateService.isHelpModeActivated$ | async)" (click)="openTopic()">
  <svg viewBox="0 0 16 16" class="icon" inlineSVG="#question-mark-circle">
  </svg>
</a>
